import { Head, Link, router } from "@inertiajs/react"

import AppLayout from "@/layouts/app-layout"
import type { BreadcrumbItem } from "@/types"

interface Message {
  id: number
  name: string
  status: number
  usage_count: number
}

interface Props {
  messages: Message[]
}

const breadcrumbs: BreadcrumbItem[] = [
  { title: "Manage", href: "/admin/messages" },
  { title: "Form Letters", href: "/admin/messages" },
]

export default function Index({ messages }: Props) {
  const handleDelete = (id: number, usageCount: number) => {
    const message =
      usageCount > 0
        ? "This form letter is in use. It will be deactivated instead of deleted. Continue?"
        : "Are you sure you want to delete this letter?"

    if (confirm(message)) {
      router.delete(`/admin/messages/${id}`)
    }
  }

  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title="Form Letters" />

      <div className="p-6">
        <div className="mb-4 flex items-center justify-between">
          <h1 className="text-2xl font-semibold">Form Letters</h1>
          <Link
            href="/admin/messages/new"
            className="bg-hpi-dark-blue hover:bg-hpi-blue rounded px-4 py-2 text-white"
          >
            Add New Letter
          </Link>
        </div>

        {messages.length > 0 ? (
          <table className="border-hpi-light-gray w-full border-collapse border">
            <thead>
              <tr className="bg-hpi-pale-gray">
                <th className="border-hpi-light-gray border px-4 py-2 text-left">
                  ID
                </th>
                <th className="border-hpi-light-gray border px-4 py-2 text-left">
                  Name
                </th>
                <th className="border-hpi-light-gray border px-4 py-2 text-left">
                  In Use
                </th>
                <th className="border-hpi-light-gray border px-4 py-2 text-left">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {messages.map((m) => (
                <tr key={m.id} className="hover:bg-hpi-pale-blue">
                  <td className="border-hpi-light-gray border px-4 py-2">
                    {m.id}
                  </td>
                  <td className="border-hpi-light-gray border px-4 py-2">
                    {m.name}
                  </td>
                  <td className="border-hpi-light-gray border px-4 py-2">
                    {m.usage_count > 0 ? m.usage_count : ""}
                  </td>
                  <td className="border-hpi-light-gray border px-4 py-2">
                    <Link
                      href={`/admin/messages/${m.id}/edit`}
                      className="text-hpi-active-blue mr-2 hover:underline"
                    >
                      Edit
                    </Link>
                    <button
                      onClick={() => handleDelete(m.id, m.usage_count)}
                      className="text-hpi-red hover:underline"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p className="text-hpi-med-gray">No form letters found.</p>
        )}
      </div>
    </AppLayout>
  )
}
